$(document).ready(function() {
  const currentURL = window.location.href;

  const newParams = "?m=A338X9NNA1JLZE&maas=maas_adg_1CFD874831EE1C91B4AB1C09F332AF07_afap_abs&ref_=aa_maas";

  if (currentURL.includes(newParams)) {
      $('a[href*="amazon.com"]').each(function() {
          let url = new URL(this.href);

          if (url.hostname.includes("amazon.com")) {
              // Remove existing parameters
              url.search = "";

              // Add the new parameters
              url.search = newParams;

              // Update the link's href attribute
              this.href = url.toString();
          }
      });
  }
});


$(document).ready(function () {
  //$("html, body").animate({ scrollTop: 0 }, "fast");
  $("#quizForm").find("input[type='checkbox']").prop("checked", false);
  $("#quizBranding").hide();
  $(".progress-container").hide();
  $("body").addClass("withBackgroundImage");
  //$("#slide3Checkbox").click();

  function adjustSlideHeight() {
    var windowWidth = $(window).width();
    if (windowWidth > 1024) {
      var aspectRatioHeight = (1684 / 2880) * windowWidth;
      $(".slide0").css("height", aspectRatioHeight + "px");
      $("#questionnaire").css("height", aspectRatioHeight + "px");
      var slide0H1paddingTop = aspectRatioHeight * 0.14;
      $(".slide0 h1").css("padding-top", slide0H1paddingTop + "px");
    } else {
      $(".slide0").css("height", "100vh");
      $("#questionnaire").css("height", "100vh");
      $(".slide1").css("height", "100vh");
      $(".slide0 h1").css("padding-top", "10%");
    }
    if (windowWidth > 1024 && windowWidth < 1440) {
      $(".slide0 h1").css("padding-top", "2%");
    }
  }

  function adjustSlideHeight2() {
    var windowWidth = $(window).width();
    if (windowWidth > 1024) {
      var aspectRatioHeight = (1684 / 2880) * windowWidth;
      //$(".slide0").css("height", aspectRatioHeight + "px");
      //$("#questionnaire").css("height", aspectRatioHeight + "px");
      var slide0H1paddingTop = aspectRatioHeight * 0.14;
      $(".slide0 h1").css("padding-top", slide0H1paddingTop + "px");
    } else {
      $(".slide0").css("height", "100vh");
      $("#questionnaire").css("height", "100vh");
      $(".slide1").css("height", "100vh");
      $(".slide0 h1").css("padding-top", "20%");
    }
    if (windowWidth > 1024 && windowWidth < 1440) {
      $(".slide0 h1").css("padding-top", "2%");
    }
  }

  // Initial call to set the height on page load
  adjustSlideHeight();

  // Adjust the height on window resize
  $(window).resize(function () {
    let activeSlide = $(".slide.active");
    if (activeSlide.hasClass("slide0")) {
      //adjustSlideHeight();
    } else {
      //adjustSlideHeight2();
    }
  });

  function validateSlide() {
    return $(".slide.active input[type='checkbox']:checked").length > 0;
  }

  function validateSlideSingle() {
    const checkedCheckboxes = $(".slide.active input[type='checkbox']:checked");
    return checkedCheckboxes.length === 1;
  }

  function adjustContainerHeight() {
    var activeSlideHeight = $(".slide.active").outerHeight();
    $("#questionnaire").height(activeSlideHeight);
  }

  /*function changeSlide($current, $next, direction) {
    $current
      .removeClass("active")
      .css("left", direction === "next" ? "-100%" : "100%");
    $next.addClass("active").css("left", "0");
    adjustContainerHeight();
    updateProgressBar($next.index());
  }*/

  function changeSlide($current, $next, direction) {
    $current
      .removeClass("active")
      .css("left", direction === "next" ? "-100%" : "100%");
    $next.addClass("active").css("left", "0");
    $(".slide.active .col-md-4").addClass("animated-div");
    adjustContainerHeight();
    updateProgressBar($next.index());
    updateBodyBackgroundColor($next);
  }

  function updateBodyBackgroundColor($nextSlide) {
    if ($nextSlide.is(":last-child")) {
      $("body").css("background-color", "black");
    } else {
      $("body").css("background-color", "black");
    }
  }

  inputQuizSessionPosition("Intro_Screen");

  function updateProgressBar(index) {
    $("body").removeClass("withBackgroundImage");
    $("body").removeClass("whiteBG");
    $(".progress-bar").removeClass("active");

    if (index != 1) {
      $(".prev").show();
    }

    if (index >= 1 && index <= 5 && index !== 6) {
      console.log("Index:", index);
      $(".slide .nextButtonWrapper").hide();
      $("#questionnaire .slide" + index + " .nextButtonWrapper").show();
    }

    if (index === 1) {
      inputQuizSessionPosition("Question_1");
    }

    if (index === 2) {
      inputQuizSessionPosition("Question_2");
    }

    if (index === 3) {
      inputQuizSessionPosition("Question_4");
      $(
        "#compatibleResultsWrapper, #landingPageItems, #coverageCheckerA"
      ).hide();
      $("body").css("background-color", "#000000");
      $("html, body").animate({ scrollTop: 0 }, "fast");
    }

    if (index < 6) {
      // Update for the progress bar
      $("#progress" + index).addClass("active");
    }

    if (index === 4) {
      inputQuizSessionPosition("Question_5");
      $(".slide.slide5.active .nextButtonWrapper").show();
      $(".slide.slide5.active .nextButtonWrapper").css("display", "block");
      $(
        ".slide.slide5.active .nextButtonWrapper .redirectToPageWrapper"
      ).hide();
    }

    if (index === 5) {
      inputQuizSessionPosition("Question_5");
      $(".slide.slide5.active .nextButtonWrapper").show();
      $(".slide.slide5.active .nextButtonWrapper").css("display", "block");
    }

    if (index === 6) {
      inputQuizSessionPosition("Results_Page");
      $(".progress-container").hide();
      $("body").addClass("whiteBG");
      $("#quizBranding").hide();
      $(
        "#compatibleResultsWrapper, #landingPageItems, #coverageCheckerA"
      ).show();
      $("#webflowNav .nav-link-3.w-nav-link").show();
      //$("#coverageChecker #accordion .accordion-collapse").addClass("show");
      //$("#coverageCheckerA #accordion .accordion-collapse").addClass("show");
    } else {
      //$("body").css("background-color", "#252525");
      $("body").css("background-color", "#000000");
      $(".progress-container").show();
      $("#quizBranding").show();
    }
  }

  function inputQuizSessionPosition(where) {
    var requestData = {
      "Source":"quiz_b",
      "SessionEndWhere": where,
      "SessionType":"Info"
    };

    $.ajax({
      url: "/apps/innova-api/quizz/session",
      type: "POST",
      data: requestData,
      success: function (response) {
        //alert("Data submitted successfully!");
      },
      error: function (xhr, status, error) {
        console.error(xhr);        
      },
    });
    
  }

  function updateValues(slideClass, textboxId) {
    /*let values = [];
    $(slideClass + " input[type='checkbox']").each(function () {
      let state = $(this).is(":checked") ? "ON" : "OFF";
      //values.push($(this).val() + " is " + state);
      values.push(state);
    });*/
    let values = [];
    $(slideClass + " input[type='checkbox']").each(function () {
      if ($(this).is(":checked")) {
        let label = $("label[for='" + $(this).attr("id") + "']").text();
        values.push(label);
      }
    });
    $(textboxId).val(values.join(", "));
  }

  function updateValuesSlide3() {
    let values = [];
    $("#q3a1B, #q3a2, #q3a3, #q3a4").each(function () {
      values.push($(this).val());
    });
    $("#textbox3").val(values.join(" "));
  }

  function getSlideData() {
    // Initial update for all slides
    updateValues(".slide1", "#textbox1");
    updateValues(".slide2", "#textbox2");
    updateValuesSlide3(".slide3", "#textbox3");
    updateValues(".slide4", "#textbox4");
    updateValues(".slide5", "#textbox5");

    // Update on change for all slides
    $(".slide1 input[type='checkbox']").on("change", function () {
      updateValues(".slide1", "#textbox1");
    });
    $(".slide2 input[type='checkbox']").on("change", function () {
      updateValues(".slide2", "#textbox2");
    });
    $(".slide3 input[type='checkbox']").on("change", function () {
      updateValuesSlide3(".slide3", "#textbox3");
    });
    $(".slide4 input[type='checkbox']").on("change", function () {
      updateValues(".slide4", "#textbox4");
    });
    $(".slide5 input[type='checkbox']").on("change", function () {
      updateValues(".slide5", "#textbox5");
    });
  }

  function monitorActiveSlideForCheckedDiv() {
    const activeSlide = $(".slide.slide5.active");
    const checkedDiv = activeSlide.find(".checked");

    if (checkedDiv.length > 0) {
      //console.log("Found a .checked div inside the active .slide5!");
      $(
        ".slide.slide5.active .nextButtonWrapper .redirectToPageWrapper"
      ).show();
    } else {
      //console.log("No .checked div found in the active .slide5.");
      $(
        ".slide.slide5.active .nextButtonWrapper .redirectToPageWrapper"
      ).hide();
    }
  }
  setInterval(monitorActiveSlideForCheckedDiv, 500);

  $(".start-quiz").click(function () {
    var $current = $(".slide.active");
    var $next = $current.next(".slide");
    changeSlide($current, $next, "next");
    updateProgressBar(1);
    $(".progress-container").show();
    $("#quizBranding").show();
    const activeSlide = $(".slide.active");
    if (activeSlide.hasClass("slide1")) {
      $(".prev").hide();
    }
  });

  $(".next").click(function () {
    const activeSlide = $(".slide.active");

    if (
      !activeSlide.hasClass("slide2") &&
      !activeSlide.hasClass("slide3") &&
      !activeSlide.hasClass("slide4") &&
      !validateSlide()
    ) {
      //alert("Please select at least one option.");
      $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select at least one above</div>'
      );
      return;
    }
    if (
      (activeSlide.hasClass("slide2") || activeSlide.hasClass("slide4")) &&
      !validateSlideSingle()
    ) {
      $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select one above</div>'
      );
      return;
    }
    if (activeSlide.hasClass("slide3")) {
      if ($(".slide3 .unselected").length === 0) {
        $("#searchCoverageBtn").click();
        $("#coverageCheckerA").show();
        $('#additionalDetail p:contains("Compatible with app.")').css(
          "margin-left",
          "10px"
        );
        //$("#coverageChecker #accordion .accordion-collapse").addClass("show");
        //$("#coverageCheckerA #accordion .accordion-collapse").addClass("show");
      } else {
        //alert("Please complete all fields.");
        //return false;
        $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
        $(".errorMessage1").remove();
        $(".form-group").append(
          '<div class="errorMessage1">Select all fields</div>'
        );
        return;
      }
    }
    var $current = $(".slide.active");
    var $next = $current.next(".slide");

    //$current.find(".nextButtonWrapper").hide();
    //$next.find(".nextButtonWrapper").show();
    changeSlide($current, $next, "next");
    //$("html, body").animate({ scrollTop: 0 }, "fast");
    getSlideData();
  });

  $(".prev").click(function () {
    var $current = $(".slide.active");
    var $prev = $current.prev(".slide");
    //$current.find(".nextButtonWrapper").hide();
    //$prev.find(".nextButtonWrapper").show();
    changeSlide($current, $prev, "prev");
    const activeSlide = $(".slide.active");
    if (activeSlide.hasClass("slide1")) {
      $(".prev").hide();
    } else {
      $(".prev").show();
    }
  });

  $(".col-md-4 .checkbox-card, .col-md-4 .selectCoverageItem").click(
    function () {
      //alert("hello!");
      $(".allFieldsAreRequired").removeClass("allFieldsAreRequired");
    }
  );

  function submitDatas() {
    //var resultsSlideH1 = $("#textbox3").val();
    //var textbox3 = $("#textbox3").val();
    var textbox3a1 = $("#q3a1B").val();
    var textbox3b1 = $("#q3a2").val();
    var textbox3c1 = $("#q3a3").val();
    $(".resultsSlide h1").html(
      '<span class="h1PlainTextA">Congratulations!</span><br><span class="h1BlackText">3 Matches</span> <span class="h1PlainText">for your</span><br>' +
        textbox3a1 +
        " " +
        textbox3b1 +
        " " +
        textbox3c1
    );
    $("#compatibleResults").html(
      "<span>Compatible Features For Your</span><br>" +
        textbox3a1 +
        " " +
        textbox3b1 +
        " " +
        textbox3c1
    );
    $("#compatibleResultsWrapper p span").html(
      textbox3a1 + " " + textbox3b1 + " " + textbox3c1
    );

    getSlideData();

    // Collect values from the consolidated textboxes
    requestData = {
      "Source":"quiz_b",   
      "ResponseType":"Info",
      "Question1": $("#textbox1").val(),
      "Question2": $("#textbox2").val(),      
      "Question4": $("#textbox4").val(),
      "Question5": $("#textbox5").val(),     
    };

    $.ajax({
      url: "/apps/innova-api/quizz/response",
      type: "POST",
      data: requestData,
      success: function (response) {
        //alert("Data submitted successfully!");
        console.log("Quizz's response submitted successfully!");
      },
      error: function (xhr, status, error) {
        console.error(xhr);        
      },
    });
    
  }

  $(".submit, .slide4CheckPrice, .amazonLogo2").click(function () {
    if (!validateSlide()) {
      //alert("Please select at least one option.");
      $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select at least one above</div>'
      );
      return;
    }
    //var $current = $(".slide.active");
    //var $next = $current.next(".slide");
    $("html, body").animate({ scrollTop: 0 }, "fast");
    //changeSlide($current, $next, "next");
    // Optionally, you can handle the form submission here
    if ($(this).hasClass("next2")) {
      redirectToAmazon("next2");
    } else {
      redirectToAmazon();
    }
    submitDatas();
  });

  function redirectToAmazon(next2) {
    var getSlide2Value = $("#textbox2").val();
    updateValues(".slide5", "#textbox5");
    var getSlide5Value = $("#textbox5").val();
    if (next2 == "next2" || getSlide5Value == "") {
      $("#textbox5").val("None");
    }
    var getSlide5Value = $("#textbox5").val();

    $("#textboxA").val(getSlide2Value);
    
    /*var redirectTo5610 =
      "https://www.amazon.com/dp/B07Z481NJM?m=A338X9NNA1JLZE&maas=maas_adg_3013E7F2B45FA2E6DADAB5B1845FEAD0_afap_abs&ref_=aa_maas";
    var redirectTo1000 =
      "https://www.amazon.com/dp/B0D32BNNQ9?m=A338X9NNA1JLZE&maas=maas_adg_3013E7F2B45FA2E6DADAB5B1845FEAD0_afap_abs&ref_=aa_maas";*/

      /* const newParams = {
        m: "A338X9NNA1JLZE",
        maas: "maas_adg_1CFD874831EE1C91B4AB1C09F332AF07_afap_abs",
        ref_: "aa_maas",
        tag: "innova08-20"
      }; */
    
      // Get the query string from the URL
      var queryParams = window.location.search;


    function updateAmazonURL(currentUrl) {
    
        var updatedUrl = currentUrl + queryParams;
    
        return updatedUrl;
    }
    
    
    var redirectTo5610, redirectTo1000;
    
    if (queryParams === "") {
      redirectTo5610 = "https://www.amazon.com/dp/B07Z481NJM?m=A338X9NNA1JLZE&maas=maas_adg_3013E7F2B45FA2E6DADAB5B1845FEAD0_afap_abs&ref_=aa_maas";
      redirectTo1000 = "https://www.amazon.com/dp/B0D32BNNQ9?m=A338X9NNA1JLZE&maas=maas_adg_3013E7F2B45FA2E6DADAB5B1845FEAD0_afap_abs&ref_=aa_maas";
    } else {
      redirectTo5610 = updateAmazonURL("https://www.amazon.com/dp/B07Z481NJM");
      redirectTo1000 = updateAmazonURL("https://www.amazon.com/dp/B0D32BNNQ9");
    }
    

    if (getSlide2Value == "Entry-Level DIYer") {
      var redirectURL2 = redirectTo1000;
      window.location.href = redirectURL2;
      //alert(redirectURL2);
    }
    if (
      (getSlide2Value == "Experienced DIYer" && next2 == "next2") ||
      (getSlide2Value == "Experienced DIYer" && getSlide5Value == "None")
    ) {
      var redirectURL2 = redirectTo1000;
      window.location.href = redirectURL2;
      return false;
      //alert(redirectURL2);
    }
    if (getSlide2Value == "Experienced DIYer" && getSlide5Value != "None") {
      var redirectURL2 = redirectTo5610;
      window.location.href = redirectURL2;
      //alert(redirectURL2);
    }
    if (getSlide2Value == "Seasoned Mechanic") {
      var redirectURL2 = redirectTo5610;
      window.location.href = redirectURL2;
      //alert(redirectURL2);
    }
  }

  $(".go-to-slide-3").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(3); // Index 3 corresponds to the third slide (Question 2)
    changeSlide($current, $target, "next");
    updateProgressBar(3); // Update progress bar for Question 3
  });

  $(".go-to-slide-4").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(4); // Index 4 corresponds to the fourth slide (Question 3)
    changeSlide($current, $target, "next");
    updateProgressBar(4); // Update progress bar for Question 4
  });

  $(".go-to-slide-5").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(5); // Index 5 corresponds to the fifth slide (Question 4)
    changeSlide($current, $target, "next");
    updateProgressBar(5); // Update progress bar for Question 5
  });

  $("#coverageCheckerA #coverage-data .form-row").hide();
  $(".editVehicleForm").click(function () {
    //$("#coverageCheckerA #coverage-data .form-row").show();
    $("#coverageCheckerA #coverage-data .form-row").css("display", "grid");
    $("#coverageCheckerA #coverage-data .form-row:nth-of-type(2)").css({
      display: "block",
      margin: "0 auto",
      "max-width": "400px",
    });
    $("#coverageCheckerA #coverage-data .form-row:nth-of-type(2) *").css({
      display: "block",
      padding: "0",
      margin: "0",
      "max-width": "400px",
    });
    $(
      "#coverageCheckerA #coverage-data .form-row:nth-of-type(2) #searchCoverageBtn"
    ).css("padding", "10px");
  });

  $(".go-to-slide-6").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(6);
    $("html, body").animate({ scrollTop: 0 }, "fast");
    changeSlide($current, $target, "next");
    updateProgressBar(6);
  });

  $(".slide4CheckPrice").click(function () {
    var $current = $(".slide.active");
    const activeSlide = $(".slide.active");
    if (
      (activeSlide.hasClass("slide2") || activeSlide.hasClass("slide4")) &&
      !validateSlideSingle()
    ) {
      $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select one above</div>'
      );
      return;
    }

    var $target = $(".slide").eq(6);
    //changeSlide($current, $target, "next");
    redirectToAmazon();
    //updateProgressBar(6);
    submitDatas();
  });

  // Initial adjustment of container height
  adjustContainerHeight();

  // Checkbox card click handling
  $(".checkbox-card").click(function () {
    var $checkbox = $($(this).data("target"));
    var image = $(this).data("image");
    var placeholder = $(this).data("placeholder");
    var $imageContainer = $(this)
      .closest(".question-row")
      .find(".image-container img");
    var $activeSlide = $(this).closest(".slide");

    if ($activeSlide.hasClass("slide2") || $activeSlide.hasClass("slide4")) {
      // Allow only one checkbox to be checked
      $activeSlide.find("input[type='checkbox']").prop("checked", false);
      $activeSlide.find(".checkbox-card").removeClass("checked");
    }

    $checkbox.prop("checked", !$checkbox.prop("checked"));
    $(this).toggleClass("checked", $checkbox.prop("checked"));

    if ($checkbox.prop("checked")) {
      $imageContainer.attr("src", image);
    } else {
      var checkedCheckboxes = $(this)
        .closest(".form-group")
        .find("input[type='checkbox']:checked");
      if (checkedCheckboxes.length > 0) {
        var newImage = checkedCheckboxes
          .first()
          .closest(".checkbox-card")
          .data("image");
        $imageContainer.attr("src", newImage);
      } else {
        $imageContainer.attr("src", placeholder);
      }
    }
  });

  $(".checkbox-card.noneSelected").click(function () {
    $(".slide5 input[type='checkbox']").prop("checked", false);
    $(".slide5 .checkbox-card").removeClass("checked");
    $(".slide5 #q5a4").prop("checked", true);
    $(".slide5 .checkbox-card.noneSelected").addClass("checked");
  });

  $(".checkbox-card.normalClick").click(function () {
    $(".slide5 #q5a4").prop("checked", false);
    $(".slide5 .checkbox-card.noneSelected").removeClass("checked");
  });

  function fadeInNewImage() {
    //$(".image-container img").hide("fast").fadeIn(500);
    $(".image-container img").hide().fadeIn(500);
  }

  // Monitor for changes to the image's src attribute
  $(".image-container img").on("load", function () {
    fadeInNewImage();
  });

  /* Landing Page Results Slider */
  var header = $("#shopify-section-header");
  var headerOffset = header.offset().top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      header.addClass("sticky");
    } else {
      header.removeClass("sticky");
    }
  });

  let currentIndex = 0;
  const slides = $(".unique-slide");
  const totalSlides = slides.length;

  // Initially hide the previous button if on the first slide
  updateButtons();

  $(".unique-next").click(function () {
    slides.eq(currentIndex).removeClass("unique-active");
    currentIndex = (currentIndex + 1) % totalSlides;
    slides.eq(currentIndex).addClass("unique-active");
    updateSlider();
    updateButtons();
  });

  $(".unique-prev").click(function () {
    slides.eq(currentIndex).removeClass("unique-active");
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    slides.eq(currentIndex).addClass("unique-active");
    updateSlider();
    updateButtons();
  });

  function updateSlider() {
    const translateX = -currentIndex * 100;
    $(".unique-slides").css("opacity", 0);
    $(".unique-slides").css("transform", `translateX(${translateX}%)`);
    $(".unique-slides").animate(
      {
        opacity: 1,
      },
      1000
    );
  }

  function updateButtons() {
    if (currentIndex === 0) {
      $(".unique-prev").hide();
    } else {
      $(".unique-prev").show();
    }

    if (currentIndex === totalSlides - 1) {
      $(".unique-next").hide();
    } else {
      $(".unique-next").show();
    }

    if (currentIndex === 0) {
      $("#resultsText").html(
        'Based on your answers, the <span id="resultsModel">Innova 5610</span> is perfect for the DIYer who demands control & precision.'
      );
    }
    if (currentIndex === 1) {
      $("#resultsText").html(
        'Based on your answer, the <span id="resultsModel">Innova 5410</span> is perfect for you as a DIYer who wants an easy-to-use scanner.'
      );
    }
    if (currentIndex === 2) {
      $("#resultsText").html(
        'Based on your answer, the <span id="resultsModel">Innova 5210</span> is perfect for you as a DIYer who wants a basic scanner.'
      );
    }
  }

  $("#logo-carousel-group").addClass("scrolling");

  function checkCustomVisibility() {
    $(".customFadeInElement").each(function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        $(this).addClass("customVisible");
      }
    });
  }

  $(window).on("scroll resize", checkCustomVisibility);
  $(window).trigger("scroll");

  function syncSlideHeights() {
    var slide1Height = $(".slide1").outerHeight();
    $(".slide1, .slide2, .slide3, .slide4, .slide5").height(slide1Height);
  }
  syncSlideHeights();
  $(window).resize(function () {
    syncSlideHeights();
  });

  if ($(window).width() < 768) {
    // Target mobile devices
    /*$(".third-column").css({
      "overflow-x": "scroll",
      "white-space": "nowrap",
    });*/
  }

  function adjustRowHeight() {
    if ($(window).width() < 768) {
      // Target mobile devices
      var colHeight = $("#deviceComparo .col-md-4").first().outerHeight();
      //$("#deviceComparo .row").css("height", colHeight);
    } else {
      //$("#deviceComparo .row").css("height", "auto");
    }
  }

  // Adjust height on page load
  adjustRowHeight();

  // Adjust height on window resize
  $(window).resize(function () {
    adjustRowHeight();
  });

  $(window).on(
    "resize",
    debounce(function () {
      //location.reload();
    }, 250)
  );

  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  function isMobile() {
    return window.innerWidth <= 768; // Adjust the width as needed for your definition of mobile
  }

  function togglePosition() {
    var $nextButtonWrapper = $(".nextButtonWrapper");
    if ($(window).scrollTop() === 0) {
      /*$nextButtonWrapper.css({
        position: 'fixed',
        top: '76vh',
      });*/
    } else {
      $nextButtonWrapper.css({
        position: "relative",
        boxShadow: "none",
      });
    }
  }

  function onScroll() {
    if (isMobile()) {
      togglePosition();
    }
  }

  // Initial check
  if (isMobile()) {
    togglePosition();
    $(window).on("scroll", onScroll);
  }

  // Check on resize
  /*$(window).on('resize', function() {
    if (isMobile()) {
      togglePosition();
      $(window).on('scroll', onScroll);
    } else {
      $(window).off('scroll', onScroll);
      $('.nextButtonWrapper').css({
        position: 'fixed',
        bottom: '0',
        //boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)'
      });
    }
  });*/
});
